import { FunctionComponent, SVGProps, useMemo } from 'react';

import UserAgentIcon from '@sbu/assets.svg/src/browser.svg';
import CommandIcon from '@sbu/assets.svg/src/command.svg';
import CustomEntityIcon from '@sbu/assets.svg/src/custom-entity.svg';
import DeploymentIcon from '@sbu/assets.svg/src/deployment.svg';
import DomainIcon from '@sbu/assets.svg/src/domain.svg';
import EmailIcon from '@sbu/assets.svg/src/email.svg';
import FileIcon from '@sbu/assets.svg/src/file.svg';
import HashIcon from '@sbu/assets.svg/src/hash.svg';
import HostIcon from '@sbu/assets.svg/src/host.svg';
import IpAddressIcon from '@sbu/assets.svg/src/ip.svg';
import MacIcon from '@sbu/assets.svg/src/mac.svg';
import PodIcon from '@sbu/assets.svg/src/pod.svg';
import ProcessIcon from '@sbu/assets.svg/src/process.svg';
import ReplicaSetIcon from '@sbu/assets.svg/src/replica-set.svg';
import UrlIcon from '@sbu/assets.svg/src/url.svg';
import UserIcon from '@sbu/assets.svg/src/user.svg';
import { FolderIcon } from '@sumologic/yama-ds-icons';

import { useCustomEntityTypes } from 'app/Entities';

export type EntityTypeOption = {
  value: string;
  name: string;
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
};

export const defaultEntityTypeOptions: EntityTypeOption[] = [
  { value: '_ip', name: 'IP Address', icon: IpAddressIcon },
  { value: '_mac', name: 'MAC Address', icon: MacIcon },
  { value: '_username', name: 'Username', icon: UserIcon },
  { value: '_hostname', name: 'Hostname', icon: HostIcon },
  { value: '_process', name: 'Process', icon: ProcessIcon },
  { value: '_command', name: 'Command', icon: CommandIcon },
  { value: '_hash', name: 'Hash', icon: HashIcon },
  { value: '_domain', name: 'Domain', icon: DomainIcon },
  { value: '_useragent', name: 'User Agent', icon: UserAgentIcon },
  { value: '_email', name: 'Email', icon: EmailIcon },
  { value: '_url', name: 'URL', icon: UrlIcon },
  { value: '_file', name: 'File', icon: FileIcon },
  { value: '_deployment', name: 'Deployment', icon: DeploymentIcon },
  { value: '_pod', name: 'Pod', icon: PodIcon },
  { value: '_replicaset', name: 'ReplicaSet', icon: ReplicaSetIcon },
  { value: '_resource', name: 'Resource', icon: FolderIcon },
];

export const useEntityTypeOptions = () => {
  const { data: customTypesData, loading, error } = useCustomEntityTypes();

  const entityTypeOptions = useMemo(() => {
    const customTypes =
      customTypesData?.customEntityTypes?.objects?.map(
        ({ identifier: value, name }) => ({
          value,
          name,
          icon: CustomEntityIcon,
        })
      ) || [];

    return [...defaultEntityTypeOptions, ...customTypes];
  }, [customTypesData]);

  return {
    loading,
    error,
    entityTypeOptions,
  };
};
